/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import * as _ from 'lodash'

import { useOnMount } from '@utils/reactExt'
import useRootStore from '@store/useRootStore'

import ReceivedImg from '@assets/images/icon/etc_icon/odds_maker_Icon.png'
// css
import { Title, TitleWrap } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { Schema$UserMission } from '@interface/common'
import { getIconByPropertyId } from '@utils/jsxutils'
import menus from '@views/PrimaryLayout/menu'
import { MissionWrap } from './index.style'
import * as Utils from '../../../utils/utils'

const Received = (
  <img src={ReceivedImg} alt="수령 완료" className="mission-list--item--reward--img received-img" />
)

const Mission: React.FC = () => {
  const { authStore, routerStore, userStore } = useRootStore()
  const { missionList } = userStore

  useOnMount(async () => {
    if (!authStore.isSignedIn) {
      routerStore.push('/')
    }

    await userStore.getUserMissionList()
  })

  const onClickMission = async (mission: Schema$UserMission) => {
    if (Utils.isMissionCompleted(mission)) {
      if (!mission.rewardComplete) {
        await userStore.pickUpMissionReward(mission)
      }
    }
  }

  const renderMissionListPanel = (): React.ReactElement => {
    if (!_.isEmpty(missionList)) {
      const missionComponents: React.ReactElement[] = []
      for (const mission of missionList) {
        let componentClassName = 'mission-list--item disabled'
        let rewardText = '보상 받기'
        if (Utils.isMissionCompleted(mission)) {
          if (mission.rewardComplete) {
            componentClassName += ' received disabled'
            rewardText = '완료'
          } else {
            componentClassName += ' achievement cursor-pointer'
          }
        }
        missionComponents.push(
          <Button key={mission.id} className={componentClassName} onClick={() => onClickMission(mission)}>
            <span className="mission-list--item--reward">
              {getIconByPropertyId(mission.propertyId, 'mission-list--item--reward--img')}
              {Received}
            </span>

            <span className="mission-list--item--mission-txt">
              {mission.name}
            </span>
            <span className="mission-list--item--reward-status">{rewardText}</span>
          </Button>,
        )
      }
      return <Fragment>{missionComponents}</Fragment>
    }
    return null
  }

  const pathName = routerStore.location.pathname
  const missionMenu = _.find(menus, { namespace: 'mission' })

  return (
    <Fragment>
      {pathName === missionMenu.path && (
        <TitleWrap className="title-wrap modal">
          <Title className="title">미션</Title>
        </TitleWrap>
      )}
      <MissionWrap>
        <h3 className="mission-notice">보상 받기 시 미션을 완료한 횟수만큼 일괄 지급됩니다.</h3>
        <div className="mission-list">
          {/*
          <Button> className
            미달성 : default
            미션 달성 및 미수령 : achievement 추가
            미션 보상 수령 완료 : received 추가
          */}
          {renderMissionListPanel()}
        </div>
      </MissionWrap>
    </Fragment>
  )
}

export default observer(Mission)
